export function Onboarding() {
  return (
    <div className="p-4 space-y-6">
      <header className="pt-2">
        <h1 className="text-2xl font-bold">Welcome to WholeWorm</h1>
        <p className="text-white/50 text-sm">Let's set things up</p>
      </header>

      <section className="card">
        <div className="text-center py-8">
          <span className="text-4xl mb-4 block">🎯</span>
          <h3 className="text-lg font-medium mb-2">Quick Setup</h3>
          <p className="text-white/50 text-sm mb-4">
            Connect your calendars and we'll start helping you prioritize
          </p>
          <button className="btn-primary">Get Started</button>
        </div>
      </section>
    </div>
  );
}
